




import Vue from 'vue'
import Component from 'vue-class-component'
import VueMultiselect from 'vue-multiselect'
import { Injector } from '@/config/dependency-injection'
import { SharedModule } from '@/shared/store/shared-module'
import { Prop, Watch } from 'vue-property-decorator'
import { OfferLite } from '@/business/offers/models/offer-lite'

@Component({
  components: { VueMultiselect },
  data() {
    return {
      internalValue: undefined,
    }
  },
})
export default class RespondecoOfferSelect extends Vue {
  @Prop({
    type: Object,
  })
  public readonly value!: OfferLite

  public internalValue!: OfferLite

  private sharedModule = Injector.get(SharedModule)

  public get offers(): OfferLite[] {
    return this.sharedModule.data.offers
  }

  public mounted() {
    this.sharedModule.fetchSharedOffers()
  }

  /**
   * Emit new value
   */
  public updateValue(value: OfferLite) {
    this.$emit('input', value)
  }

  /**
   * Prop value changed
   * @param newValue
   */
  @Watch('value')
  public onValueChanged(newValue: OfferLite): void {
    this.internalValue = newValue
  }
}
